import { ServerEnv } from 'Configs/ServerEnv'
import httpHelper from 'Services/HttpHelper'

const GetGenealogyItems = async ({ baId, ushopCountryCode, showOnlyTotalLeg3 = 1, options = 'SortOV', token = '', customerType = 'all', byPassCache = false }) => {
    const url = `${ServerEnv.MemberCalls2()}/etlV2/genealogy`
    const qs = {
        baId,
        ushopCountryCode,
        showOnlyTotalLeg3,
        options
    }

    if (customerType !== 'all') {
        qs.customerType = customerType
    }

    if (byPassCache) {
        qs.byPassCache = 1
    }

    return httpHelper.Get({ url, config: { params: qs, headers: { 'authorization-hydra': `Bearer ${token}` } } })
}

const FetchUserFilter = async ({ baId, ushopCountryCode, token = '' }) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/remoteStorage/genealogyFilter/${ushopCountryCode}/${baId}?t=${new Date().getTime()}`
    return httpHelper.Get({ url, config: { headers: { 'authorization-hydra': `Bearer ${token}` } } })
}

const SaveGenealogyFilter = async ({
    baId,
    sortByOv,
    view = 'table',
    showActiveLeg,
    showFsb = false,
    showApv = false,
    showCpv = false,
    showDistributor = false,
    showMember = false,
    isLargeLevels = false,
    showAll = false,
    swapTableView = false,
    token = ''
}) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/remoteStorage/genealogyFilter`
    const data = {
        baId,
        sortByOv,
        view,
        showActiveLeg,
        showFsb,
        showApv,
        showCpv,
        showDistributor,
        showMember,
        isLargeLevels,
        showAll,
        swapTableView
    }
    return httpHelper.Post({ url, data, config: { headers: { 'authorization-hydra': `Bearer ${token}` } } })
}

export const GenealogyAPI = {
    GetGenealogyItems,
    FetchUserFilter,
    SaveGenealogyFilter
}
